import {
  Button,
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import Gene20Box from "../../Components/Gene20Box/Gene20Box";
import workHome from '../../Assets/Images/topview.jpg'

export default function Blog() {
  return (
    <Gene20Box sx={{ width: "100%" }}>
      <Gene20Box
        sx={{
          textTransform: "uppercase",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography>
          welcome to our blog
          <Divider />
        </Typography>
      </Gene20Box>
      <Card sx={{ padding: "2vh" ,mb:"2vh"}}>
        <Typography sx={{ textTransform: "uppercase" }}>
          how to make money online
          <Divider />
        </Typography>
        <CardMedia component="img" image={workHome} height="200px" width="200px" alt=""/>
        <CardActions>
          <Button variant="contained">View article</Button>
        </CardActions>
      </Card>
      <Card sx={{ padding: "2vh", mb:"2vh" }}>
        <Typography sx={{ textTransform: "uppercase" }}>
          how to make money online
          <Divider />
        </Typography>
        <CardMedia component="img" image={workHome} height="200px" width="200px" alt=""/>
        <CardActions>
          <Button variant="contained">View article</Button>
        </CardActions>
      </Card>
    </Gene20Box>
  );
}
